import { useAppContext } from "@/appContext";
import ActionStepCard from "./ActionStepCard";
import { useEffect } from "react";
import Loading from "react-loading";

const ActionSteps = () => {
  const { state, asyncGetAction } = useAppContext();

  useEffect(() => {
    if (
      !state.displayPastFeedback && state.session[state.currentQuestion].feedback !== "" &&
      state.session[state.currentQuestion].actionsteps === ""
    ) {
      asyncGetAction();
    }
  }, [
    state.displayPastFeedback,
    state.session[state.currentQuestion].actionsteps,
  ]);

  if (
    !state.displayPastFeedback &&
    state.session[state.currentQuestion].actionsteps === ""
  )
    return (
      <div className="h-[100vh] flex justify-center items-center">
        <Loading color="#000000" width={100} height={100} type="bubbles" />
      </div>
    );

  if (!state.session[state.currentQuestion].actionsteps)
    return (
      <div className="flex h-[100vh] overflow-scroll py-[30px] pr-[48px] flex-col gap-4 overflow-x-hidden">
        Unable to load action steps
      </div>
    );

  return (
    <div className="flex h-[100vh] overflow-scroll py-[30px] pr-[48px] flex-col gap-4 overflow-x-hidden">
      {state.session[state.currentQuestion].actionsteps
        .split("<br/><br/>")
        .map((a) => a.split(":"))
        .map((actionObject, i) => (
          <ActionStepCard
            key={i}
            title={actionObject.at(0)?.replaceAll("*", "") || ""}
            desc={actionObject.at(1) || ""}
          />
        ))}
    </div>
  );
};

export default ActionSteps;
